import * as XLSX from "xlsx";
import { statusInfo } from "@/constants/statuses";

export const exportMetersToExcel = (meters) => {
  const rows = meters.map((m) => ({
    ID: m.ref || "",
    Rue: m.rue || "",
    "N°": m.numero || "",
    NPA: m.npa || m.code_postal || "",
    Lieu: m.lieu || "",
    "Statut Excel": m.statut ? statusInfo(m.statut).label : "",
    "Statut app": m.statut_app ? statusInfo(m.statut_app).label : "",
    "Date relevé": m.releve_date || "",
    Latitude: m.lat ?? "",
    Longitude: m.lng ?? "",
  }));
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [10, 30, 6, 8, 20, 22, 18, 14, 12, 12].map((wch) => ({ wch }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Compteurs");
  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `compteurs_sig_${date}.xlsx`);
};
